<script setup lang="ts">
import Icon from "@/core/components/icon/Icon.vue";
import useLaboratoryColor from "@/laboratory/composables/useLaboratoryColor";

const componentProps = defineProps<{
    color: string;
}>();

const {primaryWithOpacity} = useLaboratoryColor({primary: componentProps.color});
</script>

<template>
  <div class="bg-white rounded-md">
    <div
      class="px-3 py-2 flex items-center h-full gap-2"
      :style="{
        color: componentProps.color,
        backgroundColor: primaryWithOpacity
      }"
    >
      <div class="text-xl flex-1">
        <slot />
      </div>
      <v-tooltip v-if="$slots['tooltip']" location="bottom">
        <template #activator="{ props }">
          <div v-bind="props" class="flex items-center gap-2">
            <Icon name="mdi-information-outline" :size="20" :color="color" />
          </div>
        </template>
        <div class="text-sm max-w-sm">
          <slot name="tooltip" />
        </div>
      </v-tooltip>
    </div>
  </div>
</template>

<style scoped>

</style>
